import { render, staticRenderFns } from "./list-dict-value.vue?vue&type=template&id=f3a50fd4&scoped=true"
import script from "./list-dict-value.vue?vue&type=script&lang=js"
export * from "./list-dict-value.vue?vue&type=script&lang=js"
import style0 from "./list-dict-value.vue?vue&type=style&index=0&id=f3a50fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a50fd4",
  null
  
)

export default component.exports